export interface WebsiteIssue {
  id: string;
  slug: string;
  title: string;
  status: "draft" | "active" | "done" | "archived";
  priority: "high" | "medium" | "low";
  tags: string[];
  folder: string;
  body: string;
  excerpt: string;
  createdAt: string;
  updatedAt: string;
}

export interface IssuesResponse {
  issues: WebsiteIssue[];
}

export async function fetchIssues(): Promise<IssuesResponse> {
  const res = await fetch("/api/issues");
  if (!res.ok) throw new Error(`Failed to load issues (${res.status})`);
  return res.json();
}

export async function fetchAllIssues(): Promise<IssuesResponse> {
  const res = await fetch("/api/issues?all=true");
  if (!res.ok) throw new Error(`Failed to load issues (${res.status})`);
  return res.json();
}

export async function createIssue(data: {
  title: string;
  body?: string;
  priority?: string;
}): Promise<{ success: boolean; slug: string }> {
  const res = await fetch("/api/issues", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error(`Failed to create issue: ${res.statusText}`);
  return res.json();
}
